import { auditSupplierAccount } from "@/apis/supplier";
import {
  ApprovalForm,
  ApprovalFormFields,
} from "@/components/ApprovalForm/ApprovalForm";
import CommonModal from "@/components/ui/CommonModal";
import { useModal } from "@/hooks/modals/useModal";
import { SupplierAccountAuditParams } from "@/types/apis";
import { notifySuccess } from "@/utils/notification";
import { useMutation } from "@tanstack/react-query";

export const AuditSupplierAccountModal = () => {
  const { open, props, closeModal } = useModal("SUPPLIER_SUB_REGISTER");
  const { onSuccess, registrantId } = props;

  const auditMutation = useMutation({
    mutationFn: (data: SupplierAccountAuditParams) =>
      auditSupplierAccount(data),

    onSuccess() {
      notifySuccess("审核成功");
      onSuccess?.();
      closeModal();
    },
  });

  const handleApprovalSubmit = (values: ApprovalFormFields) => {
    auditMutation.mutate({
      itemId: registrantId,
      status: values.skipType === "PASS" ? 1 : 2, // 1通过 2驳回
      opinion: values.message,
    });
  };
  return (
    <CommonModal
      open={open}
      onCancel={closeModal}
      title="供应商账号审核"
      width={800}
      footer={null}
    >
      <div style={{ padding: "20px" }}>
        <ApprovalForm
          onApprovalSubmit={(values) => handleApprovalSubmit(values)}
        />
      </div>
    </CommonModal>
  );
};
